// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3nBS1","header":"ReportDetails_header__3wABR","title":"ReportDetails_title__1ZYnd","left":"ReportDetails_left__3_yaE"};